import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { AdminTabBar } from "./AdminTabBar";
import { AdminWorkspacePanel } from "./AdminWorkspacePanel";
import { AdminTabId, resolveAdminTab } from "./adminTabs";
import "./AdminWorkspace.scss";

export const AdminWorkspace = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = resolveAdminTab(searchParams.get("tab"));

  const handleTabChange = useCallback(
    (tab: AdminTabId) => {
      setSearchParams({ tab }, { replace: true });
    },
    [setSearchParams]
  );

  return (
    <div className="admin-workspace">
      <div className="admin-workspace__tabs-card">
        <AdminTabBar activeTab={activeTab} onTabChange={handleTabChange} />
      </div>
      <div className="admin-workspace__content-card">
        <AdminWorkspacePanel activeTab={activeTab} />
      </div>
    </div>
  );
};
